/**
 * VideoSearchIcon — A magnifier in a viewfinder: the search of the video. Hugeicons scan-search
 * (MIT).
 */

import svg from './svg/video-search.svg?raw';
import { makeSvgIcon } from './svgIcon';

export const VideoSearchIcon = makeSvgIcon('video-search', svg);
